import { render } from "./FollowupCaseDetails.vue?vue&type=template&id=7f0b19c6&scoped=true"
import script from "./FollowupCaseDetails.vue?vue&type=script&lang=js"
export * from "./FollowupCaseDetails.vue?vue&type=script&lang=js"

import "./FollowupCaseDetails.vue?vue&type=style&index=0&id=7f0b19c6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src745183879/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0b19c6"]])

export default __exports__